import { render, staticRenderFns } from "./TableField.vue?vue&type=template&id=f4367d44&scoped=true&"
import script from "./TableField.vue?vue&type=script&lang=js&"
export * from "./TableField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4367d44",
  null
  
)

export default component.exports